import { Inject, Pipe, PipeTransform, makeStateKey, TransferState } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { IS_SERVER } from '@app/modules/core/tokens/app.tokens';

import { merge } from '@app/util/util';

export const TRANSLATION_KEY = makeStateKey('TRANSLATIONS');

@Pipe({
  name: 'translation',
  standalone: false
})
export class TranslatePipe implements PipeTransform {

  constructor(private translateService: TranslocoService,
              @Inject(IS_SERVER) public isServer: boolean,
              private transferState: TransferState) { }

  transform(query: string, interpolateParams?: Object): string {
    let translations = JSON.parse(this.transferState.toJson())[TRANSLATION_KEY];
    const value = this.translateService.translate(query, interpolateParams);
    if (this.isServer) {
      if (translations) {
        const obj = this.mapToObject(query, value);
        translations = merge(translations, obj);
        this.transferState.set(TRANSLATION_KEY, translations);
      } else {
        const obj = this.mapToObject(query, value);
        this.transferState.set(makeStateKey(TRANSLATION_KEY), obj as unknown);
      }
    }

    return value;
  }

  private mapToObject(query: string, value: string): Object {
    const array = query.split('.');
    const obj = {};
    array.reduce((o, s, i) => {
      if (i === (array.length - 1)) {
        return o[s] = value;
      } else {
        return o[s] = {};
      }
    }, obj);

    return obj;
  }
}
